import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { buildBasicListRequestParams } from '@app/helpers/listQuery.helper';
import { UserAccount } from '@app/models/account.model';
import { UserSimpleResponse } from '@app/models/admin.model';
import { LegalEntityWithUser } from '@app/models/project.models';
import {
  ComplexPaginatedDataRequest,
  PaginatedData,
} from '@app/models/shared.models';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getUsers(
    params: ComplexPaginatedDataRequest = {}
  ): Observable<PaginatedData<UserAccount>> {
    const requestParams = buildBasicListRequestParams(params);

    return this.http.get<PaginatedData<UserAccount>>(`${this.API_URL}/Users`, {
      params: requestParams,
    });
  }

  getTempToken(userId: string): Observable<any> {
    return this.http.get(`${this.API_URL}/user/${userId}/temptoken`);
  }

  getUserById(userId: string): Observable<UserAccount> {
    return this.http.get<UserAccount>(`${this.API_URL}/user/${userId}`);
  }

  getPersonalData(userId: string): Observable<any> {
    return this.http.get(`${this.API_URL}/user/${userId}/PersonalData`);
  }

  deactivateUser(userId: string): Observable<void> {
    return this.http.put<void>(`${this.API_URL}/User/${userId}/Deactivate`, {});
  }

  reactivateUser(userId: string): Observable<void> {
    return this.http.put<void>(`${this.API_URL}/User/${userId}/Reactivate`, {});
  }

  updateUser(userId: string, payload: any) {
    return this.http.put(`${this.API_URL}/User/${userId}`, payload);
  }

  skipPersonalVerification(userId: string) {
    return this.http.put<void>(
      `${this.API_URL}/User/${userId}/SkipPersonalVerification`,
      {}
    );
  }

  resetPassword(userId: string): Observable<any> {
    return this.http.get(`${this.API_URL}/User/${userId}/ResetPassword`, {});
  }

  deleteUser(userId: string): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/User/${userId}/Delete`);
  }

  getAllApprovalRequests(userId: string) {
    return this.http.get<LegalEntityWithUser[]>(
      `${this.API_URL}/User/${userId}/GetAllApprovalRequests`,
      {}
    );
  }

  getProjectAdmins(): Observable<UserSimpleResponse[]> {
    return this.http.get<UserSimpleResponse[]>(
      `${this.API_URL}/User/ProjectAdmins`
    );
  }
}
